import React from "react";
import { Link } from "react-router-dom";

// Renders a Learn-more entry from educational.js LEARN_MORE.
// Published notes link to /blog/:slug. Episodes link to /radio/:slug.
// comingSoon entries render a flat, non-clickable card with a yellow badge.
const LearnMoreCard = ({ item, testId }) => {
  const isEpisode = item.type === "episode";
  const kicker = isEpisode ? "Radio Kostaja" : "Note";
  const published = item.status === "published";

  if (!published) {
    return (
      <li data-testid={testId} className="bg-black p-6 flex items-start justify-between gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-bold k-yellow mb-2">{kicker}</div>
          <div className="text-lg lg:text-xl font-black tracking-tight leading-tight">{item.title}</div>
        </div>
        <span className="shrink-0 inline-flex items-center text-[10px] uppercase tracking-[0.22em] font-bold text-black bg-[#FFC600] px-2 py-1">
          Coming soon
        </span>
      </li>
    );
  }

  const href = isEpisode ? `/radio/${item.slug}` : `/blog/${item.slug}`;

  return (
    <li className="bg-black">
      <Link
        to={href}
        data-testid={testId}
        className="group block p-6 hover:bg-[#FFC600] hover:text-black transition-colors h-full"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] font-bold k-yellow group-hover:text-black mb-2">{kicker}</div>
            <div className="text-lg lg:text-xl font-black tracking-tight leading-tight">{item.title}</div>
          </div>
          <span aria-hidden className="shrink-0 text-xl group-hover:translate-x-1 transition-transform">→</span>
        </div>
        <div className="mt-4 text-[10px] uppercase tracking-[0.22em] font-bold text-white/55 group-hover:text-black/70">
          Read note
        </div>
      </Link>
    </li>
  );
};

export default LearnMoreCard;
